import type { PatientProfile, ProfileUpdatePayload } from "@/core/types";
import { patientRequestsTyped } from "@/api/(requests)/patientTyped";

export type UpdatePatientProfileVariables = ProfileUpdatePayload;

export async function updatePatientProfile(
  data: UpdatePatientProfileVariables,
): Promise<PatientProfile> {
  const body: ProfileUpdatePayload = { ...data };

  // API field name starts with a digit so it can't be modelled in the TypeScript type;
  // use Object.assign to set it without casting the whole object.
  if (data.ninety_day_care !== undefined) {
    Object.assign(body, { "90_day_care_plan": data.ninety_day_care });
  }

  // omit empty avatar to avoid clearing an existing image
  if (body.avatar === "") {
    delete body.avatar;
  }

  return patientRequestsTyped.update_profile({ body });
}
